import {setPrototypeValues} from "./values";

/**
 * https://tc39.es/ecma262/#sec-set.prototype.keys
 */
export const setPrototypeKeys = setPrototypeValues;
